import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'

class TeamFormationWindow extends StatsBaseWindow {

    render() {
        const { close_stats_window } = this.props.StatisticActions;

        return (<PopupWindow header={this.props.teamName} height={280} width={200} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <div className="formation_container">
                      <table>
                      <tr className="formation_header">
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                          <td></td><td>{this.renderShirt(23)}</td><td>{this.renderShirt(24)}</td><td>{this.renderShirt(25)}</td><td></td>
                        </tr>
                        <tr>
                          <td>{this.renderShirt(18)}</td><td>{this.renderShirt(19)}</td><td>{this.renderShirt(20)}</td><td>{this.renderShirt(21)}</td><td>{this.renderShirt(22)}</td>
                        </tr>
                        <tr>
                          <td>{this.renderShirt(13)}</td><td>{this.renderShirt(14)}</td><td>{this.renderShirt(15)}</td><td>{this.renderShirt(16)}</td><td>{this.renderShirt(17)}</td>
                        </tr>
                        <tr>
                          <td>{this.renderShirt(8)}</td><td>{this.renderShirt(9)}</td><td>{this.renderShirt(10)}</td><td>{this.renderShirt(11)}</td><td>{this.renderShirt(12)}</td>
                        </tr>

                        <tr>
                          <td>{this.renderShirt(3)}</td><td>{this.renderShirt(4)}</td><td>{this.renderShirt(5)}{this.renderShirt(2)}</td><td>{this.renderShirt(6)}</td><td>{this.renderShirt(7)}</td>
                        </tr>
                        <tr>
                          <td></td><td></td><td>{this.renderShirt(1)}</td><td></td><td></td>
                        </tr>
                      </table>
                    </div>
                </PopupWindow>)
    }

    renderShirt(num) {
      let className = "team_formation_shirt";
      className = className + (num == 2 ? " libero" : "");
      className = className + (num == 1 ? " gk" : "");
      for (var i = 0; i < this.props.formation.length; i++) {
        if(this.props.formation[i] === num){
            if(this.props.players[i].Stats.HasRedCard === true || this.props.players[i].Injured === true)
              return null;
            
            return <div className={className} title={this.props.players[i].Name.LastName} border="0"
                    style={{background: num !== 1 ? "url(https://pefl.ru/"+this.props.teamForm+") no-repeat center" : "url(https://pefl.ru/system/img/forms/491c.png) no-repeat center", backgroundSize:"contain"}}
                    width="30"><div className="shirt_num">{this.props.players[i].Number}</div>
                  </div>;
        }
      }

      return null;
    }
}

function mapStateToProps(state, ownProps) {
    var team = ownProps.home == true ? state.HomeTeam : state.AwayTeam;

    return {
      teamName: team.Name,
      players: team.Players,
      formation: team.Formation,
      position: state.statisticWindows[ownProps.id].position,
      is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
      teamBack: team.Back,
      teamColor: team.Color,
      teamForm: team.form
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamFormationWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/TeamFormationWindow.js
 **/